import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CloseDialogDirective } from '../close-dialog.directive';

@Component({
  selector: 'ui-dialog-header',
  standalone: true,
  imports: [NgClass, CloseDialogDirective],
  templateUrl: './dialog-header.component.html',
  styleUrl: './dialog-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogHeaderComponent {
  public readonly title = input.required<string>();
  public readonly subtitle = input.required<string>();
  public readonly iconName = input<string>();
}
